import { LoginPageComponent, LOGIN_CONFIG, LoginConfig } from 'app';
import { adminGuard, emailVerifiedGuard } from 'auth';
import { AppointmentsPageComponent, MyCardsPageComponent, routeBuilder } from 'credo';
import { BookingsPageComponent } from './containers/pages/bookings-page/bookings-page.component';
import { MainPageComponent } from './containers/pages/main-page/main-page.component';

// mnlo (board.mnlo.app) — credo-based re-skin. Self-registration is disabled
// (login keeps password recovery but no register link; the backend also blocks
// the newuser endpoint for this config domain). Cross-domain login is off.
// Menu/routes are limited to: Dashboard, Informationen (media/info), Meine Karten
// (mycards), Buchungen (bookings), Community. The dashboard uses the shared credo
// MainPageComponent (routeBuilder default).
export const routes = routeBuilder()
  // App-local dashboard (welcome only for now) instead of the shared credo one.
  .main(MainPageComponent)
  .withMaintenance()
  .withLegalAcknowledgement()
  .withCommunity()
  // Drop the register page entirely and disable the register link on login.
  .remove('register')
  .replace('login', {
    path: 'login',
    component: LoginPageComponent,
    providers: [
      {
        provide: LOGIN_CONFIG,
        useValue: {
          register: false,
          passwordRecovery: true,
          appInstallBottomsheet: false
        } satisfies LoginConfig
      }
    ],
    data: { animation: 'login' }
  })
  .protected(
    {
      path: 'mycards',
      component: MyCardsPageComponent,
      canActivate: [emailVerifiedGuard],
      data: { title: 'My Cards', animation: 'mycards' }
    },
    {
      // Statement of the user's 1%-pool and Church-pool movements. The backend
      // restricts mnlo to exactly those two counterparties and shows no orders.
      path: 'bookings',
      component: BookingsPageComponent,
      canActivate: [emailVerifiedGuard],
      data: { title: 'Bookings', animation: 'bookings' }
    },
    {
      // Central calendar (Phase 1). Which appointments a member sees on this
      // board is decided by the backend (calendars × audiences).
      path: 'appointments',
      component: AppointmentsPageComponent,
      canActivate: [emailVerifiedGuard],
      data: { title: 'Appointments', animation: 'appointments' }
    },
    {
      // Admin area (lazy-loaded), only reachable by admins. Operates on the
      // shared fac3less tenant (domain 0); backend admin endpoints enforce
      // admin themselves, so this works app-agnostically.
      path: 'admin',
      canMatch: [adminGuard],
      canActivate: [adminGuard],
      loadChildren: () =>
        import('./admin/admin.routes').then(m => m.ADMIN_ROUTES)
    }
  )
  .build();
